import { makeStyles } from "@material-ui/core";

const defaultBorder = (theme): string => {
  return theme.palette.border.input;
};

export const useStyles = makeStyles(
  (theme) => ({
    root: {},

    containerStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "nowrap",
    },

    inputStyle: {
      width: "34px !important",
      height: 34,
      outline: 0,
      marginLeft: "0.8rem",
      border: `1px solid ${defaultBorder(theme)}`,

      fontSize: 16,
      fontWeight: theme.typography.fontWeightMedium,
      textAlign: "center",
    },

    focusStyle: {
      border: `1px solid ${theme.palette.secondary.main}`,
    },

    errorStyle: {
      color: theme.palette.error.main,
      border: `1px solid ${theme.palette.error.main}`,
    },
  }),
  { name: "input-otp-style", flip: null }
);
